import React from "react";
import { alpha, Typography } from "@mui/material";
import { dsColorNew } from "@palette"

// One quiet corner over both header levels, so the dates lead.
export default function officeProvidersHeader() {

    return {
        setHeaderCellProps: () => ({
            sx:{
                backgroundColor: dsColorNew.tableHead,
                position: 'sticky',
                top: 0,
                left: 0,
                zIndex: '160 !important',
                border: 0,
                verticalAlign: 'middle',
                minWidth: 150,
            }}),
        render: () => <Typography sx={{ textAlign: 'left', textTransform: 'none', fontWeight: 500, fontSize: 12.5, color: alpha(dsColorNew.white, 0.72) }}>
            Branch / Providers
        </Typography>
    }
}
